import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa'

export const  socialIconLink = [
    { id: "fa", label: <FaFacebook />, to: "https://www.facebook.com", colori: "green.400" , aLabel :"Facebook"},
    { id: "tw", label: <FaTwitter />, to: "https://www.twitter.com", colori: "green.400" , aLabel :"twitter"},
    { id: "in", label: <FaInstagram />, to: "https://www.instagram.com", colori: "green.400", aLabel :"Instagram" }
]

export const linkListFooter = [
    { id: "PP", url: "/privacy", label: "Privacy" },
    { id: "T", url: "/terms", label: "Terms" },
    { id: "C", url: "/contact", label: "Contact" }
]